import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { SatisfactionService } from 'src/app/services/satisfaction-services/satisfaction-service/satisfaction.service';
import { HeaderBreadcrumbService } from '../../header-components/header-breadcrumb/header-breadcrumb.service';
import * as moment from 'moment/moment';

@Component({
  selector: 'app-satisfaction-satisfactions-dashboard',
  templateUrl: './satisfaction-satisfactions-dashboard.component.html',
  styleUrls: ['./satisfaction-satisfactions-dashboard.component.scss']
})
export class SatisfactionSatisfactionsDashboardComponent implements OnInit, OnDestroy {

  satisfactions;
  getSatisfactionsSubscription: Subscription;
  listenRefreshSatisfactionsSubscription: Subscription;

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService,
              private satisfactionService: SatisfactionService) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.listenRefreshSatisfactions();
    this.getSatisfactionsList(moment().startOf('day').valueOf(), moment().valueOf());
    this.setBreadcrumb();
  }

  private listenRefreshSatisfactions() {
    this.listenRefreshSatisfactionsSubscription = this.satisfactionService.listenRefreshSatisfactions().pipe(
      tap(o => this.getSatisfactionsList(o['from'], o['to']))
    ).subscribe();
  }

  private getSatisfactionsList(from, to) {
    this.getSatisfactionsSubscription = this.satisfactionService.getSatisfactionsList(from, to).pipe(
      tap(o => this.satisfactions = o)
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-star-half-alt', 'satisfactions-page.ratings', '/satisfaction', [new BRoute('satisfactions-page.satisfaction', '/satisfaction'), new BRoute('satisfactions-page.ratings')]));
  }

  ngOnDestroy() {
    if (this.getSatisfactionsSubscription) { this.getSatisfactionsSubscription.unsubscribe(); }
    if (this.listenRefreshSatisfactionsSubscription) { this.listenRefreshSatisfactionsSubscription.unsubscribe(); }
  }

}
